module.exports = __webpack_public_path__ + "__assets__/img/news-swiper-h5.0cc9a5e4.png";